import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { store } from 'store';

import * as S from './TargetFrame.styles';

export const TargetFrame: FC = observer(() => {
  const { targetFrameActive: isActive, targetFrameX: x, targetFrameY: y } = store.galaxyStore;
  return (
    <S.Container $isActive={isActive} style={{ left: `${x}px`, top: `${y}px` }}>
      <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Corner brackets */}
        <g filter="url(#glow)">
          <path d="M8 32V8H32" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" />
          <path d="M88 8H112V32" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" />
          <path d="M112 88V112H88" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" />
          <path d="M32 112H8V88" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" />
        </g>

        {/* Outer rotating dashed ring */}
        <circle
          cx="60"
          cy="60"
          r="38"
          stroke="#00ff88"
          strokeWidth="1"
          strokeDasharray="6 8"
          opacity="0.4"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 60 60"
            to="360 60 60"
            dur="6s"
            repeatCount="indefinite"
          />
        </circle>

        {/* Inner counter-rotating ring */}
        <circle
          cx="60"
          cy="60"
          r="22"
          stroke="#00ff88"
          strokeWidth="1"
          strokeDasharray="3 5"
          opacity="0.5"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="360 60 60"
            to="0 60 60"
            dur="4s"
            repeatCount="indefinite"
          />
        </circle>

        {/* Crosshair lines */}
        <g stroke="#00ff88" strokeWidth="1" opacity="0.6">
          <line x1="60" y1="10" x2="60" y2="28" />
          <line x1="60" y1="92" x2="60" y2="110" />
          <line x1="10" y1="60" x2="28" y2="60" />
          <line x1="92" y1="60" x2="110" y2="60" />
        </g>

        {/* Small diamond ticks at 45° */}
        <g fill="#00ff88" opacity="0.5">
          <rect x="58.5" y="30" width="3" height="3" transform="rotate(45 60 31.5)" />
          <rect x="58.5" y="86" width="3" height="3" transform="rotate(45 60 87.5)" />
          <rect x="30" y="58.5" width="3" height="3" transform="rotate(45 31.5 60)" />
          <rect x="86" y="58.5" width="3" height="3" transform="rotate(45 87.5 60)" />
        </g>

        {/* Center dot with pulsing glow */}
        <circle cx="60" cy="60" r="3" fill="#00ff88" filter="url(#glow)">
          <animate attributeName="r" values="2.5;4;2.5" dur="2s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="1;0.6;1" dur="2s" repeatCount="indefinite" />
        </circle>
      </svg>
    </S.Container>
  );
});
